import { Popup } from 'antd-mobile'
import React, { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import Dialog from '../../../lib/Dialog'
import ChatList from '../chatList/ChatList'
import {NavLink} from '../../../lib/Navigation'
import './css/IncomeAlert.css'

export default function ShareAlert(props) {

  const [visible,setVisible] = useState(true)
  const [chatVisible,setChatVisible] = useState(false)

  const close = ()=>{
    if (props.close){
      props.close()
    }
  }

  return (
    <div>
      <Popup 
        visible={visible} 
        bodyStyle={{
          borderTopLeftRadius: '13px',
          borderTopRightRadius: '13px',
          padding:'15px 15px 0'
        }}>
        <div className='share-alert-container'>
          <div className="alert-title" >选择要分享至</div>
          <div className="content">
            <NavLink className="item" onClick={()=>{
              setVisible(false)
              setChatVisible(true)
            }}>
              <img className='icon' src="resources/250410/chat.png" alt="" />
              <div className='value'>群聊</div>
            </NavLink>
            <CopyToClipboard text={props.shareUrl} onCopy={()=> {
              Dialog.info('已复制链接')
              close()
            }}>
              <div className="item">
                <img className='icon'src="resources/250410/copy.png" alt="" />
                <div className='value'>复制链接</div>
              </div>
            </CopyToClipboard>
          </div>
          <div className="cancel" onClick={close}>取消</div>
        </div>
      </Popup>
      {chatVisible && <ChatList extra={props.extra || {}} topic_id={props.topic_id} id={props.id} subtype={props.subtype} visible={chatVisible} close={()=>{
        setVisible(true)
        setChatVisible(false)
        close()
      }}></ChatList>}
    </div>
    
  )
}
